import { ENV } from "#app/env";
import { resetTimer } from "#app/lib/activityTimer";
import { navigateWithPageReload } from "#app/lib/navigation";
import { Button } from "#ui/button";
import { Icon } from "#ui/icon";
import { cx } from "#ui/style.utils";

import { useCountdown } from "./Countdown";
import { activityTimerName } from "./InactivityTimer";

export function AutoLogoffBanner({ status }: { status: boolean }) {
  const timeRemaining = useCountdown({
    onCountdownComplete: () => {
      // Using `window` methods to ensure vendor sessions are destroyed.
      navigateWithPageReload("/sign-out?sessionExpired=true");
    },
    countdownTime: ENV.autoLogOffCountdownTime,
    status: status,
  });

  return (
    <div
      // Intentional live announcements use role status.
      // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role
      role="status"
      className={cx(
        "grid grid-cols-[auto,1fr] items-center gap-5px",
        "px-20px py-10px md:px-30px",
        "bg-warning-20 text-shade-100",
        "text-sm",
      )}
    >
      <Icon name="ms-warning-filled" palette="warning" />
      <span className="sr-only">Warning</span>
      <span>
        Your Baird Online session will expire in{" "}
        <span className="font-semibold">{timeRemaining}</span> seconds.{" "}
        <Button
          onClick={() => {
            resetTimer(activityTimerName, {});
          }}
          variant="link"
          underline
        >
          Click here to continue using Baird Online.
        </Button>
      </span>
    </div>
  );
}
